import { Operation } from '@dbl/core/filter';

import type { IColor } from '../type';

export const DEFAULT_RULE_COLOR: IColor = {
  hexa: '#13bf4f',
  alpha: '100',
};

export const RULE_COLORS: Record<string, IColor> = {
  green: { hexa: '#13bf4f', alpha: '100' },
  red: { hexa: '#f05858', alpha: '100' },
  gray: { hexa: '#bbbfc7', alpha: '100' },
};

/** 示例数据：旧 operator 键到 Operation 枚举 */
export const LEGACY_OPERATOR_MAP: Record<string, Operation> = {
  gt: Operation.Greater,
  lt: Operation.Less,
  eq: Operation.Equal,
};

